import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';

export const getAdminConversationCategoryList = async () => {
    // @ts-ignore
    const url = routable.getRoute('adminCommunicationCategoryList');
    try {
        const response = await $api.get(url);
        return response.data;
    } catch (error) {
        handleAxiosFetchErrorsSwal(error?.response?.data);
        return error.message;
    }
};
